import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';
import type { WizardContext } from '@swf/core/types/Wizard';

import useEkycTransitionScreenCheck from '../../../../hooks/useEkycTransitionScreenCheck';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import RMFEKYCTransitionScreen from '../RMFEKYCTransitionScreen/RMFEKYCTransitionScreen';

import DataSummary from './DataSummary/DataSummary';
import {
  TXTCLI_Confirm,
  TXTCLI_Summary,
  TXTWCL_Please_check_that_your_persona_ELL,
  TXTWCL_We_are_having_trouble_verifyin_ELL
} from './RMFSummaryScreen.messages.json';

const RMFSummaryScreen: React.FC = () => {
  const {
    values: { firstName, middleName, lastName }
  }: WizardContext = useWizardContext();
  const fullName = [firstName, middleName, lastName].filter(Boolean).join(' ');
  const shouldShowEKYCTransition = useEkycTransitionScreenCheck();
  const siteId = useSelector(select.cms.getSiteId);
  const isUK = siteId === Sites.UK;
  const [enableConfirm, setEnableConfirm] = useState(false);

  return (
    <Container
      page={RMFSummaryScreen}
      headerProps={{
        title: isUK ? fullName : <Translation {...TXTCLI_Summary} />,
        buttons: { back: false }
      }}
      pageTopTitle={<Translation {...TXTWCL_We_are_having_trouble_verifyin_ELL} />}
      pageTopSubtitle={<Translation {...TXTWCL_Please_check_that_your_persona_ELL} />}
    >
      {shouldShowEKYCTransition && <RMFEKYCTransitionScreen transitionType="checkDetails" />}
      <DataSummary handleCompleteForm={() => setEnableConfirm(true)} />
      <CTAButton translation={TXTCLI_Confirm} disabled={!enableConfirm} />
    </Container>
  );
};

RMFSummaryScreen.displayName = 'RMFSummaryScreen';

export default RMFSummaryScreen;
